<!--suppress TypeScriptUnresolvedVariable -->
<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<div *ngIf="currentUser != null" class="wrapper" [class.no-subsidiary]="!currentUser.subsidiaryId" (click)="menu.toggle($event)">
    <div *ngIf="!deviceManager.isMobile"><i class="fa fa-layer-group"></i></div>
    <div class="subsidiary-name-area">
        <div *ngIf="deviceManager.isMobile" class="subsidiary-label">Subsidiary: </div>
        <div *ngIf="currentUser.subsidiaryId != null" class="subsidiary-text">{{subsidiaryName}}</div>
    </div>
</div>

<p-menu #menu [popup]="true" [model]="subsidiaryItems">
    <ng-template pTemplate="start" *ngIf="!authManager.currentUser.isGlobalReader">
        <div *ngIf="authManager.currentUser.isUberAdmin" (click)="menu.toggle();addSubsidiaryFormVisible = true" style="width: 100%; font-size: 1.1rem; font-weight: bold; cursor: pointer; text-align: center; border-bottom: 1px solid rgba(0,0,0,.2); padding: 4px 0;"><i class="pi pi-plus"></i> Add subsidiary</div>
    </ng-template>
</p-menu>

<div class="add-subsidiary-form" *ngIf="addSubsidiaryFormVisible" [formGroup]="addSubsidiaryForm">
    <div>
        <input type="text" formControlName="name">
        <div>Name</div>
    </div>
    <div>
        <input type="text" formControlName="abbreviatedName">
        <div>Abbreviated Name</div>
    </div>
    <div>
        <input type="text" formControlName="displayName">
        <div>Display Name</div>
    </div>
    <div>
        <input type="text" formControlName="legalName">
        <div>Legal Name</div>
    </div>
    <div class="buttons">
        <p-button (click)="addSubsidiaryFormVisible = false; addSubsidiaryForm.reset()">Cancel</p-button>
        <p-button [disabled]="!addSubsidiaryForm.valid" (click)="addSubsidiaryFormVisible = false; addSubsidiary()">Save</p-button>
    </div>
</div>